module.exports = __webpack_public_path__ + "img/lang-16.bdc98d56.jpg";